'use client';

import {
  StarterKit,
  TiptapUnderline,
  HighlightExtension,
  Placeholder,
  Command,
  createSuggestionItems,
  renderItems
} from 'novel';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableHeader from '@tiptap/extension-table-header';
import TableCell from '@tiptap/extension-table-cell';
import { EditableImage } from './extensions/editable-image';
import { CustomLink } from './extensions/custom-link';

// Define default extensions to be used in the editor
export const defaultExtensions = [
  StarterKit.configure({
    heading: {
      levels: [1, 2, 3, 4, 5],
    },
  }),
  CustomLink,
  TiptapUnderline,
  HighlightExtension,
  Placeholder.configure({
    placeholder: ({ node, editor, pos }) => {
      if (node.type.name === 'heading') {
        return `Heading ${node.attrs.level}`;
      }

      // Don't show placeholder in table cells or table headers
      if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') {
        return '';
      }

      // Check if this node is inside a table by checking parent nodes
      if (editor && pos !== undefined) {
        try {
          const $pos = editor.state.doc.resolve(pos);
          for (let depth = $pos.depth; depth > 0; depth--) {
            const parentNode = $pos.node(depth);
            if (parentNode.type.name === 'tableCell' || parentNode.type.name === 'tableHeader' || parentNode.type.name === 'table') {
              return '';
            }
          }
        } catch (e) {
          // If there's an error resolving position, just continue
        }
      }

      return 'Press "/" for commands...';
    },
    showOnlyCurrent: true, // Only show placeholder on the current/active node
    showOnlyWhenEditable: true,
    includeChildren: true,
    emptyNodeClass: 'is-empty',
    emptyEditorClass: 'is-editor-empty',
  }),
  EditableImage,
  // Add TaskList and TaskItem extensions for task list support
  TaskList.configure({
    HTMLAttributes: {
      class: 'task-list',
    },
  }),
  TaskItem.configure({
    HTMLAttributes: {
      class: 'task-item',
    },
    nested: true,
  }),
  Table.configure({
    resizable: true,
    HTMLAttributes: {
      class: 'border-collapse table-auto w-full',
    },
  }),
  TableRow,
  TableHeader,
  TableCell,
];
